import { DefaultPluginLoader, PluginExecutor, PluginParser, PluginRegistry, getPluginLoader, registerPluginLoader, DATA_ATTR_NAMESPACE } from "@jetjs/core";
import { WorkerTaskExecutorPool } from "@jetjs/threadpool";
let instance;
// register included Plugin loader
registerPluginLoader(new DefaultPluginLoader());
const jet = {
    init: (opts) => {
        if (instance) {
            throw new Error("Already initiated.");
        }
        const ns = opts.namespace || DATA_ATTR_NAMESPACE;
        const threadPool = new WorkerTaskExecutorPool({
            workerScript: opts.threadPoolWorkerSrc || "/js/worker.js",
            minWorker: opts.threadPoolMinSize || 2,
            maxWorker: opts.threadPoolMaxSize || 2
        });
        instance = {
            namespace: ns,
            threadPool,
            pluginParser: new PluginParser(threadPool, ns, opts.parsingBatchSizeFactor),
            pluginExecutor: new PluginExecutor(threadPool, getPluginLoader(opts.pluginLoadingStrategy))
        };
    },
    run: (elements) => {
        if (!instance) {
            throw new Error("Initiate before run. Call #init() to do that");
        }
        const arrayOfElements = Array.isArray(elements) ? elements : [elements];
        if (arrayOfElements.length >= 1) {
            instance.pluginParser.parse(arrayOfElements, (node, defs) => {
                instance.pluginExecutor.execute(node, defs);
            }, err => {
                throw err;
            });
        }
    },
    searchAndRun: function (element = document.body) {
        if (!instance) {
            throw new Error("Initiate before run. Call #init() to do that");
        }
        this.run(instance.pluginParser.findAll(element));
    },
    registerPlugin: (name, fn) => {
        PluginRegistry.getInstance().register(name, fn);
    },
    registerPluginAlias: (alias, name, defaultParameter) => {
        PluginRegistry.getInstance().registerAlias(alias, name, defaultParameter);
    },
    registerPluginChain: (alias, fn) => {
        PluginRegistry.getInstance().registerPluginChain(alias, fn);
    }
};
export default jet;
//# sourceMappingURL=index.js.map